import { createFileRoute } from '@tanstack/react-router'
import EditClient from 'Administration/components/access/EditClient'

import AdministrationPage from '../../-administrationPage'
import { Guard, adminClaims } from '../../-guard'

export const Route = createFileRoute('/administration/clients/$id')({
    component: () => (
        <Guard claims={adminClaims}>
            <AdministrationPage>
                <EditClient />
            </AdministrationPage>
        </Guard>
    ),
})
